export default {"src":"/_next/static/media/logoPattern.2e13f44b.svg","height":568,"width":551,"blurWidth":0,"blurHeight":0};